import Icon from '../components/Icon.vue'

Icon.register({
  'balance-scale': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M256 336c0 44.2-57.3 80-128 80s-128-35.8-128-80h0c0-15.7-2.1-7.3 85-181.5 17.7-35.4 68.2-35.3 85.9 0 86.4 172.8 85.1 165.3 85.1 181.5h0zM128 176l-72 144h144zM640 336c0 44.2-57.3 80-128 80s-128-35.8-128-80h0c0-15.7-2.1-7.3 85-181.5 17.7-35.4 68.2-35.3 85.9 0 86.4 172.8 85.1 165.3 85.1 181.5zM440 320h144l-72-144zM528 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h176v-294.8c-23.5-10.3-41.2-31.5-46.4-57.3h-129.6c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h144.4c14.6-19.3 37.5-32 63.6-32s49 12.7 63.6 32h144.4c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-129.6c-5.2 25.8-22.9 47-46.4 57.3v294.8h176z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/balance-scale.js
// module id = 641
// module chunks = 0